export const DEFAULT_SHIPPING_ADDRESS_SUB_QUESTIONS = Object.freeze([
  Object.freeze({
    id: "address",
    question_text: "Street Address",
    question_type: "text",
    is_required: true,
    order_index: 0,
  }),
  Object.freeze({
    id: "address_line_2",
    question_text: "Apartment, Suite, or Unit",
    question_type: "text",
    is_required: false,
    order_index: 1,
  }),
  Object.freeze({
    id: "city",
    question_text: "City",
    question_type: "text",
    is_required: true,
    order_index: 2,
  }),
  Object.freeze({
    id: "state",
    question_text: "State",
    question_type: "state",
    is_required: true,
    order_index: 3,
  }),
  Object.freeze({
    id: "zip_code",
    question_text: "ZIP Code",
    question_type: "zip",
    is_required: true,
    order_index: 4,
  }),
]);
